import { required, concatFailure, items, shape, unique } from '@totalsoft/pure-validations';

export const financialProductSeasonalityTemplatesValidator = concatFailure(
  items(
    shape({
      templateId: required,
      default: required
    })
  ),
  unique(x=>(x.templateId) + (x.default))
);
